import React from 'react';
import { motion } from 'framer-motion';
const packs = [{
  icon: '📘',
  title: 'Pack I – Diseños de Alto Impacto Comercial',
  desc: 'Prompts optimizados para generar diseños llamativos, claros y vendibles.',
  color: 'border-blue-500',
  bullets: ['Diseños con composición fuerte y legible', 'Estética streetwear y tendencia', 'Estructuras pensadas para impresión', 'Alto contraste y claridad visual', 'Variaciones listas para escalar']
}, {
  icon: '📗',
  title: 'Pack II – Nichos Rentables',
  desc: 'Prompts enfocados en categorías que ya venden.',
  color: 'border-green-500',
  bullets: ['Anime, gaming, frases, dark, animales', 'Subnichos listos para testear', 'Ideas escalables por audiencia', 'Diseños orientados a demanda real', 'Optimización para ventas rápidas']
}, {
  icon: '📕',
  title: 'Pack III – Sistema de Vectorización IA',
  desc: 'Prompts diseñados para facilitar el paso a producción.',
  color: 'border-red-500',
  bullets: ['Estilo flat optimizado', 'Máximo 2–3 colores', 'Sin degradados', 'Bordes limpios y definidos', 'Listos para serigrafía o POD']
}, {
  icon: '📙',
  title: 'Pack IV – Variaciones Infinitas',
  desc: 'Sistema para generar múltiples diseños a partir de una base.',
  color: 'border-orange-500',
  bullets: ['40 variaciones por concepto', 'Cambios de composición automáticos', 'Adaptación rápida de estilos', 'Escalado de catálogo en horas', 'Producción masiva sin perder calidad']
}, {
  icon: '📓',
  title: 'Pack V – Frases que Venden',
  desc: 'Prompts centrados en tipografía comercial.',
  color: 'border-neutral-400',
  bullets: ['Frases con gancho emocional', 'Estructuras virales', 'Tipografía centrada y legible', 'Optimización para impacto visual', 'Diseños listos para viralizar']
}, {
  icon: '📔',
  title: 'Pack VI – Sistema Completo de Producción',
  desc: 'Todo integrado para crear sin fricción.',
  color: 'border-yellow-600',
  bullets: ['Flujo de trabajo claro', 'Sistema copy-paste', 'Optimización para Midjourney / IA', 'Consistencia en resultados', 'Ejecución rápida y repetible']
}];
export function PacksSection() {
  return <section className="py-12 md:py-24 bg-neutral-950" data-id="element-50">
      <div className="container mx-auto px-4" data-id="element-51">
        <div className="text-center mb-8 md:mb-16" data-id="element-52">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-bebas text-5xl md:text-6xl text-white uppercase tracking-wide mb-4" data-id="element-53">
            ¿Qué incluye <span className="text-brand-500" data-id="element-54">Prompt Wear?</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-neutral-400 max-w-3xl mx-auto" data-id="element-55">
            Un sistema completo de prompts listos para usar, diseñados
            específicamente para generar diseños para ropa con lógica comercial.
            <br className="hidden md:block" data-id="element-56" />
            <span className="text-neutral-300 mt-2 block" data-id="element-57">
              Incluye packs organizados por categorías para que puedas ejecutar
              desde el primer día.
            </span>
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-7xl mx-auto" data-id="element-58">
          {packs.map((pack, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-neutral-900 rounded-xl p-5 md:p-8 border-l-4 ${pack.color} border-y border-r border-y-neutral-800 border-r-neutral-800 hover:bg-neutral-800/50 transition-colors`} data-id="element-59">
              <div className="text-4xl mb-4" data-id="element-60">{pack.icon}</div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-61">
                {pack.title}
              </h3>
              <p className="text-neutral-400 text-sm mb-6 h-10" data-id="element-62">{pack.desc}</p>

              <ul className="space-y-3" data-id="element-63">
                {pack.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-sm text-neutral-300" data-id="element-64">
                    <span className="text-brand-500 mt-0.5" data-id="element-65">✓</span>
                    <span data-id="element-66">{bullet}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}